var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8253 9.42638C24.682 9.65702 25.3574 10.3325 25.5881 11.1891C26.0164 12.7542 25.9999 16.0161 25.9999 16.0161C25.9999 16.0161 25.9999 19.2616 25.5881 20.8267C25.3574 21.6833 24.682 22.3588 23.8253 22.5894C22.2602 23.0013 16 23.0013 16 23.0013C16 23.0013 9.75616 23.0013 8.17462 22.5729C7.31795 22.3423 6.6425 21.6669 6.41186 20.8102C6 19.2616 6 15.9997 6 15.9997C6 15.9997 6 12.7542 6.41186 11.1891C6.6425 10.3325 7.33443 9.64055 8.17462 9.40991C9.73969 8.99805 16 8.99805 16 8.99805C16 8.99805 22.2602 8.99805 23.8253 9.42638ZM19.2127 15.9993L14.0068 18.9977V13.001L19.2127 15.9993Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6355a484f38148569d80ed45a72029a7.svg";
export { ForwardRef as ReactComponent };